import { TravellerFieldEnum } from '@websky/graphql';
import { concatPassengerNames, getPassengerNames, getUserValue } from '../../../../utils';
export const getTravellerContactInfoValues = (values) => {
    const { lastName, firstName, middleName } = getPassengerNames({ values });
    const fullName = concatPassengerNames({ lastName, firstName, middleName });
    const email = getUserValue({ values }, TravellerFieldEnum.Email);
    const phone = getUserValue({ values }, TravellerFieldEnum.Phone);
    return { firstName, lastName, middleName, fullName, email, phone };
};
